{
  "common": {
    "save": "Salva",
    "cancel": "Annulla",
    "delete": "Elimina",
    "edit": "Modifica",
    "close": "Chiudi",
    "submit": "Invia",
    "search": "Cerca",
    "loading": "Caricamento in corso...",
    "yes": "Sì",
    "no": "No",
    "back": "Indietro",
    "next": "Avanti",
    "previous": "Precedente",
    "confirm": "Conferma",
    "done": "Completato",
    "remove": "Rimuovi",
    "add": "Aggiungi",
    "view": "Visualizza",
    "create": "Crea",
    "update": "Aggiorna",
    "ok": "OK",
    "none": "Nessuno",
    "na": "N/D",
    "prepare": "Prepara",
    "approve": "Approva",
    "uploadFiles": "Carica file",
    "learnMore": "Ulteriori informazioni",
    "user": "utente",
    "users": "utenti"
  },
  "nav": {
    "users": "Utenti",
    "groups": "Gruppi",
    "developerApiTokens": "Token API sviluppatore",
    "permissions": "Autorizzazioni",
    "betaFeatures": "Funzioni beta",
    "security": "Sicurezza",
    "adminSettings": "Impostazioni amministratore"
  },
  "pages": {
    "unauthorized": {
      "title": "Non autorizzato",
      "heading": "Siamo spiacenti!",
      "message": "Sembra che non si disponga dell'accesso a questa pagina.",
      "contactSupport": "Se ritenete che si tratti di un errore, contattate il supporto clienti."
    },
    "errorBoundary": {
      "message": "Si è verificato un errore!"
    },
    "passwords": {
      "title": "Pagina Password",
      "description": "Quando questa opzione è attivata, tutti gli utenti dell'organizzazione sono obbligati a modificare periodicamente la propria password."
    },
    "singleSignOn": {
      "title": "Pagina Single Sign On"
    },
    "logo": {
      "title": "Carica logo",
      "description": "Caricate il logo dell'organizzazione qui e verrà visualizzato nei documenti esportati."
    }
  },
  "users": {
    "searchPlaceholder": "Cerca utenti...",
    "filterByGroup": "Filtra per gruppo",
    "inviteUser": "Invita utente",
    "setRole": "Imposta ruolo",
    "addToGroup": "Aggiungi al gruppo",
    "addToGroupCount": "Aggiungi {{count}} {{pluralized}} al gruppo",
    "removeFromGroup": "Rimuovi dal gruppo",
    "removeFromGroupCount": "Rimuovi {{count}} {{pluralized}} dal gruppo",
    "manageGroups": "Manage groups",
    "manageGroupsCount": "Manage groups for {{count}} {{pluralized}}",
    "editUser": "Modifica utente",
    "removeUser": "Rimuovi utente",
    "cancelInvitation": "Annulla invito",
    "resendInvitation": "Rinvia invito",
    "usageMessage": "Stai utilizzando {{activeUsersCount}} di {{activeUsersLimit}} utenti attivi e {{totalUsersCount}} di {{totalUsersLimit}} utenti totali disponibili nel tuo piano attuale. Ne hai bisogno di più?",
    "upgradeSubscription": "Aggiorna il tuo abbonamento",
    "addMoreSeats": "Aggiungi altre licenze",
    "table": {
      "fullName": "Nome completo",
      "email": "Email",
      "role": "Ruolo",
      "jobTitle": "Qualifica",
      "department": "Reparto",
      "location": "Sede",
      "groups": "Gruppi",
      "access": "Accesso"
    },
    "inviteStatus": {
      "pending": "in sospeso",
      "declined": "rifiutato",
      "accepted": "accettato"
    },
    "editUsersUsage": "Utenti di modifica (Normal + Quality): {{activeUsersCount}} di {{activeUsersLimit}}",
    "basicUsersUsage": "Utenti di base: {{basicUsersCount}} di {{basicUsersLimit}}",
    "basicUsersUsageUnlimited": "Utenti di base: {{basicUsersCount}} (Illimitato)"
  },
  "reassignEntities": {
    "cancel": "Annulla",
    "makeReassignments": "Esegui le riassegnazioni",
    "previous": "Precedente",
    "next": "Successivo",
    "removeUser": "Rimuovi utente",
    "confirm": "Conferma",
    "save": "Salva",
    "allSelected": "Tutti i {{count}} selezionati:",
    "reviewInfo": "Rivedi le informazioni di seguito",
    "addUserToGroup": "Aggiungi utente al gruppo",
    "warningMessage": "Se procedi con la rimozione, i seguenti utenti verranno aggiunti ai seguenti gruppi richiesti per accedere ai documenti con tag privati:",
    "userAddedToGroups": "{{userName}} verrà aggiunto ai gruppi:",
    "steps": {
      "owner": "Documenti",
      "changeRequestOwner": "Richieste di modifica",
      "approver": "Azioni di approvazione",
      "reviewer": "Azioni di revisione",
      "issues": "Problemi",
      "events": "Eventi",
      "tasks": "Attività",
      "summary": "Conferma modifiche e rimuovi utente",
      "summaryRefactor": "Conferma rimozione utente",
      "default_owner": "Assegnatario evento predefinito",
      "eventTemplateOwner": "Modelli di eventi",
      "control": "Controlli",
      "documentTemplateOwner": "Modelli di documenti"
    },
    "columns": {
      "id": "ID",
      "title": "Titolo",
      "newOwner": "Nuovo proprietario",
      "status": "Stato",
      "tags": "Tag",
      "name": "Nome",
      "prefix": "Prefisso"
    },
    "summary": {
      "documents": "Documenti:",
      "documentTemplates": "Modelli di documenti:",
      "changeRequests": "Richieste di modifica:",
      "controls": "Controlli:",
      "eventTemplates": "Modelli di eventi:",
      "approvalActions": "Azioni di approvazione:",
      "reviewActions": "Azioni di revisione:",
      "issueActions": "Azioni di problemi:",
      "eventActions": "Azioni di eventi:",
      "issueCollaboratorNote": "Se un nuovo proprietario è già collaboratore di un evento, verrà rimosso dai suoi collaboratori.",
      "taskActions": "Azioni di attività:",
      "ownershipTransfer": "La proprietà di {{count}} {{type}} sarà trasferita a {{name}}",
      "ownershipTransferPlural": "La proprietà di {{count}} {{type}}s sarà trasferita a {{name}}",
      "actionTransfer": "{{count}} azione {{type}} sarà trasferita a {{name}}",
      "actionTransferPlural": "{{count}} azioni {{type}} saranno trasferite a {{name}}",
      "eventTemplateTransfer": "{{ownershipType}} di {{count}} modello di evento sarà trasferito a {{name}}",
      "eventTemplateTransferPlural": "{{ownershipType}} di {{count}} modelli di eventi saranno trasferiti a {{name}}"
    }
  },
  "groups": {
    "subtitle": "Crea e gestisci gruppi di utenti per organizzare il tuo team e controllare l'accesso",
    "createNewGroup": "Crea nuovo gruppo",
    "assignManagers": "Assegna gestori",
    "editGroup": "Modifica gruppo",
    "deleteGroup": "Elimina gruppo",
    "confirmDeleteTitle": "Conferma eliminazione gruppo",
    "confirmDeleteMessage": "Siete sicuri di voler eliminare il gruppo \"{{groupName}}\"? L'eliminazione di un gruppo che fa parte di un Piano di formazione può influire sui vostri incarichi di formazione. Controllate la Matrice di formazione per identificare i piani interessati.",
    "yesDeleteGroup": "Sì, elimina gruppo",
    "searchPlaceholder": "Cerca gruppi o gestori...",
    "table": {
      "groupName": "Nome del gruppo",
      "groupManagers": "Gestori del gruppo",
      "includeInReports": "Includi nei rapporti di formazione"
    },
    "noManagers": "--"
  },
  "groupForm": {
    "groupName": "Nome del gruppo",
    "includeInReports": "Includi nei rapporti",
    "minLengthError": "È richiesta una lunghezza minima di 1 carattere.",
    "duplicateError": "Un gruppo con il nome \"{{groupName}}\" esiste già."
  },
  "roles": {
    "basic": "Base",
    "normal": "Normale",
    "quality": "Qualità"
  },
  "features": {
    "qualityEvents": {
      "name": "Eventi di qualità",
      "description": "Un \"evento di qualità\" è un evento che richiede un'azione o una risposta predefinita e il tracciamento in conformità ai requisiti normativi. Gli utenti di qualità possono creare un evento, assegnare la proprietà e firmare i passaggi/azioni associati.",
      "enable": "Abilita eventi di qualità",
      "permissions": {
        "manageWorkflow": "Gestisci flusso di lavoro",
        "manageAttributes": "Gestisci attributi",
        "workOnIssue": "Lavora sul problema",
        "createIssue": "Crea problema",
        "view": "Visualizza eventi",
        "create": "Crea un evento",
        "workOnExisting": "Lavora su un evento esistente",
        "manageTemplates": "Crea e gestisci modelli di evento"
      }
    },
    "migrations": {
      "name": "Migrazioni",
      "description": "Il gestore migrazioni consente di caricare facilmente documenti in Qualio durante l'onboarding.",
      "enable": "Abilita migrazioni",
      "permissions": {
        "create": "Crea",
        "view": "Visualizza",
        "prepare": "Prepara",
        "approve": "Approva",
        "uploadFiles": "Carica file"
      }
    },
    "suppliers": {
      "name": "Fornitori",
      "description": "La funzione Fornitori consente al tuo team di configurare la politica dei fornitori, gestire l'elenco dei fornitori approvati e archiviare i documenti di audit dei fornitori.",
      "access": "Accedi a Fornitori"
    },
    "designControls": {
      "name": "Controlli di progettazione",
      "description": "La funzione Controlli di progettazione consente una gestione e una documentazione efficienti del processo di progettazione e sviluppo del prodotto, garantendo conformità e qualità.",
      "access": "Accedi a Controlli di progettazione"
    },
    "compliance": {
      "name": "Conformità",
      "description": "La funzione Conformità consente al tuo team di gestire i framework, tracciare lo stato dei requisiti e dimostrare l'adesione agli standard di qualità e normativi.",
      "access": "Accedi a Conformità"
    },
    "apiCapabilities": {
      "name": "Funzionalità API",
      "description": "Le funzionalità API consentono l'accesso a interfacce programmabili per l'integrazione e l'automazione senza problemi dei sistemi aziendali con documenti e formazione Qualio.",
      "access": "Accedi a Funzionalità API",
      "deprecatedNote": "Ciò consente l'accesso solo all'API legacy. Utilizza \"Token API sviluppatore\" per concedere l'accesso alla nuova API."
    },
    "events": {
      "name": "Eventi",
      "description": "La funzione Eventi consente al tuo team di creare e gestire tutti gli eventi di qualità dalla causa principale alla verifica dell'efficacia."
    },
    "notAvailable": "Questa funzione non è disponibile con la tua licenza attuale. Contatta il tuo rappresentante di Qualio Customer Success per aggiornare e abilitare gli eventi di qualità.",
    "disableConfirmation": "I dati esistenti verranno salvati e rimarranno disponibili quando le funzioni verranno riattivate. Tuttavia, tutte le autorizzazioni utente che sono state modificate verranno eliminate e ripristinate ai valori predefiniti quando la funzione verrà riattivata. Siete sicuri di voler disabilitare?",
    "disableTitle": "Disabilita {{name}}",
    "yesDisable": "Sì, disabilita {{name}}",
    "enable": "Abilita funzione",
    "disable": "Disabilita {{name}}",
    "role": "Ruolo",
    "access": "Accesso",
    "none": "Nessuno",
    "upgradeMessage": "Questa funzione non è disponibile con la tua licenza attuale. Contatta il tuo rappresentante Customer Success per aggiornare e abilitare gli eventi di qualità."
  },
  "status": {
    "draft": "Bozza",
    "forReview": "In revisione",
    "forApproval": "In attesa di approvazione",
    "approved": "Approvato",
    "approvalDeclined": "Approvazione rifiutata",
    "effective": "Effettivo"
  },
  "forms": {
    "fullName": "Nome completo",
    "email": "Indirizzo email",
    "role": "Ruolo utente",
    "adminAccess": "Accesso amministratore",
    "billingAccess": "Accesso alla fatturazione",
    "learnMoreRoles": "Ulteriori informazioni sui ruoli utente.",
    "labels": {
      "fullName": "Nome completo",
      "emailAddress": "Indirizzo email",
      "userRole": "Ruolo utente",
      "jobTitle": "Qualifica",
      "department": "Reparto",
      "location": "Sede",
      "adminAccess": "Accesso amministratore",
      "billingAccess": "Accesso fatturazione",
      "name": "Nome",
      "role": "Ruolo",
      "groups": "Gruppi"
    },
    "placeholders": {
      "whatIsThisTokenFor": "A cosa serve questo token?",
      "filterByNameEmailGroup": "Filtra per nome, email o nome del gruppo..."
    },
    "helperText": {
      "adminAccess": "La concessione dell'accesso amministratore consente agli utenti di aggiungere/rimuovere utenti e gruppi e di modificare le autorizzazioni",
      "adminAccessExtended": "La concessione dell'accesso amministratore consente agli utenti di aggiungere/rimuovere utenti, aggiungere/rimuovere gruppi e gestire le autorizzazioni per eventi e fornitori",
      "inviteUser": "Un messaggio di invito verrà inviato all'indirizzo email fornito. Conterrà un collegamento di conferma che consente al proprietario dell'indirizzo email di unirsi all'organizzazione.",
      "learnMoreRoles": "Scopri di più sui ruoli utente.",
      "learnMorePermissions": "Scopri di più sulle autorizzazioni."
    },
    "permissions": {
      "viewEvents": "Visualizza eventi",
      "createEvents": "Crea un evento",
      "editEvents": "Lavora su un evento esistente",
      "manageEvents": "Crea e gestisci modelli di eventi",
      "accessSuppliers": "Accedi ai fornitori",
      "accessDesignControls": "Accedi ai controlli di progettazione",
      "accessCompliance": "Accedi alla conformità"
    }
  },
  "apiCapabilities": {
    "header": "Funzionalità API",
    "description": "Le funzionalità API consentono l'accesso a interfacce programmabili per l'integrazione e l'automazione senza soluzione di continuità dei sistemi aziendali con documenti e formazione Qualio.",
    "deprecatedDescription": "Questo consente l'accesso solo all'API legacy. Utilizza \"Token API sviluppatore\" per concedere l'accesso alla nuova API.",
    "errorFetchKeys": "Impossibile determinare se l'azienda dispone di chiavi API a causa di un errore del server.",
    "access": "Accedi a funzionalità API"
  },
  "modals": {
    "inviteUser": {
      "title": "Invita utente",
      "sendInvitation": "Invia invito",
      "resendInvitation": "Rinvia invito",
      "reinviteMessage": "{{email}} era precedentemente un membro attivo di questo account. Reinvitarli ripristinerà il loro profilo con le attività completate in precedenza."
    },
    "setRole": {
      "title": "Imposta ruolo per gli utenti selezionati"
    },
    "addToGroup": {
      "title": "Aggiungi utenti selezionati al gruppo"
    },
    "manageGroups": {
      "title": "Manage groups for selected users",
      "save": "Save",
      "saving": "Saving...",
      "searchPlaceholder": "Filter by group name..."
    },
    "removeFromGroup": {
      "title": "Rimuovi utenti selezionati dal gruppo",
      "visibilityWarning": "Rimuovere gli utenti selezionati da questo gruppo nasconderà alcuni documenti o modelli ai loro proprietari. Sei sicuro di voler continuare?",
      "confirmTitle": "Questa azione influisce sulla visibilità dei contenuti"
    },
    "removeUser": {
      "title": "Rimuovi utente",
      "confirmMessage": "Siete sicuri di voler rimuovere l'utente \"{{name}}\"?",
      "yesRemoveUser": "Sì, rimuovi utente"
    },
    "cancelInvite": {
      "title": "Annulla invito",
      "confirmMessage": "Siete sicuri di voler annullare l'invito di questo utente?",
      "yesCancelUser": "Sì, annulla utente"
    },
    "assignManagers": {
      "title": "Assegna gestori",
      "searchPlaceholder": "Filtra per nome, email o nome del gruppo...",
      "assigning": "Assegnazione in corso...",
      "save": "Salva"
    },
    "editUser": {
      "title": "Modifica utente"
    },
    "editGroup": {
      "title": "Modifica gruppo"
    }
  },
  "editUser": {
    "title": "Modifica utente",
    "header": "Modifica utente",
    "general": "Generale",
    "permissions": "Autorizzazioni",
    "defaultPermissions": "Autorizzazioni predefinite",
    "events": "Eventi",
    "suppliers": "Fornitori",
    "designControls": "Controlli di progettazione",
    "compliance": "Conformità",
    "eventsDescription": "La funzione Eventi consente al vostro team di creare e gestire tutti gli eventi di qualità dall'analisi delle cause alla verifica dell'efficacia",
    "suppliersDescription": "La funzione Fornitori consente al vostro team di configurare la vostra politica fornitori, gestire la vostra Lista fornitori approvati e archiviare documenti di audit fornitori",
    "designControlsDescription": "La funzione Controlli di progettazione consente una gestione e documentazione efficiente del processo di progettazione e sviluppo del vostro prodotto, garantendo conformità e qualità.",
    "complianceDescription": "La funzione Conformità consente al vostro team di gestire framework, tracciare lo stato dei requisiti e dimostrare l'aderenza agli standard di qualità e normativi.",
    "eventsWarning": "La visualizzazione degli eventi deve essere selezionata per abilitare ulteriori autorizzazioni",
    "viewEventsWarning": "La visualizzazione degli eventi deve essere selezionata per abilitare ulteriori autorizzazioni",
    "resetPermissions": "Ripristina autorizzazioni predefinite",
    "resetToDefault": "Ripristina autorizzazioni predefinite",
    "saveChanges": "Salva modifiche",
    "eventsPermissions": "Autorizzazioni eventi",
    "defaultPermissionsTable": {
      "role": "Ruolo",
      "defaultPermissions": "Autorizzazioni predefinite"
    },
    "validation": {
      "invalidFullName": "Nome completo non valido",
      "invalidEmail": "Email non valida"
    }
  },
  "messages": {
    "success": {
      "saved": "Salvato con successo",
      "deleted": "Eliminato con successo",
      "submitted": "Inviato per revisione",
      "invitationSent": "Invito inviato!",
      "invitationResent": "L'invito è stato inviato di nuovo!",
      "invitationCanceled": "Invito utente annullato con successo.",
      "userRemoved": "Utente rimosso con successo.",
      "userDeleted": "Utente eliminato con successo!",
      "userUpdated": "Utente aggiornato con successo!",
      "groupCreated": "Gruppo creato con successo!",
      "groupDeleted": "Gruppo eliminato con successo!",
      "groupUpdated": "Gruppo aggiornato con successo!",
      "roleChanged": "Ruolo modificato con successo per {{count}} utente(i)!",
      "usersAdded": "{{count}} utente(i) aggiunto(i) con successo al gruppo selezionato",
      "usersRemoved": "{{count}} utente(i) rimosso(i) con successo dal gruppo selezionato",
      "groupsUpdated": "Successfully updated group membership!",
      "managersAssigned": "Gestori assegnati con successo",
      "permissionsUpdated": "Autorizzazioni istanza aggiornate con successo",
      "tokenCreated": "Nuovo token creato",
      "tokenDeleted": "Token API sviluppatore eliminato con successo",
      "tokenUpdated": "Token API sviluppatore aggiornato con successo"
    },
    "error": {
      "generic": "Si è verificato un errore. Riprovare.",
      "notFound": "Elemento non trovato",
      "unauthorized": "Non siete autorizzati a eseguire questa azione",
      "sendInvitation": "Si è verificato un errore! Impossibile inviare l'invito.",
      "resendInvitation": "Si è verificato un errore! Impossibile reinviare l'invito.",
      "cancelInvitation": "Si è verificato un errore! Impossibile annullare l'invito dell'utente.",
      "removeUser": "Si è verificato un errore! Impossibile rimuovere l'utente.",
      "updateUser": "Si è verificato un errore! Impossibile aggiornare l'utente.",
      "extractOwnedItems": "Si è verificato un errore! Impossibile estrarre gli elementi posseduti per questo utente.",
      "createGroup": "Si è verificato un errore! Impossibile creare il gruppo.",
      "deleteGroup": "Si è verificato un errore! Impossibile eliminare il gruppo.",
      "updateGroup": "Si è verificato un errore! Impossibile aggiornare il gruppo.",
      "updateRole": "Si è verificato un errore! Impossibile aggiornare il ruolo.",
      "setUsersToGroup": "Impossibile impostare gli utenti al gruppo selezionato",
      "addUsersToGroup": "Impossibile impostare gli utenti al gruppo selezionato",
      "removeUsersFromGroup": "Impossibile rimuovere utente(i) dal gruppo selezionato",
      "manageGroups": "Unable to update group membership. Please try again.",
      "assignManagers": "Impossibile assegnare i gestori",
      "updateMfa": "Impossibile aggiornare lo stato MFA per questa azienda",
      "updatePermissions": "Impossibile aggiornare le autorizzazioni istanza",
      "loadSettings": "Impossibile caricare le impostazioni.",
      "fetchFeatures": "Impossibile recuperare le funzioni",
      "updateFeatures": "Impossibile aggiornare le funzioni",
      "createToken": "Impossibile creare la chiave API richiesta a causa di un errore del server",
      "tokenNameExists": "Esiste già una chiave API con questo nome. Scegli un nome diverso.",
      "deleteToken": "Impossibile eliminare la chiave API richiesta a causa di un errore del server",
      "rotateToken": "Impossibile ruotare la chiave API richiesta a causa di un errore del server",
      "showApiKeys": "Impossibile visualizzare le chiavi API a causa di un errore del server",
      "reassignEntities": "Impossibile riassegnare le entità. Riprova.",
      "updateToken": "Impossibile aggiornare il token API richiesto a causa di un errore del server"
    },
    "validation": {
      "required": "Questo campo è obbligatorio",
      "invalidEmail": "Indirizzo email non valido.",
      "minLength": "Deve contenere almeno {{min}} caratteri",
      "maxLength": "Non deve superare {{max}} caratteri",
      "invalidTokenName": "Nome del token non valido",
      "minimumAdmins": "Questa operazione comporterebbe zero amministratori per l'azienda. Il numero minimo di amministratori richiesti per ogni azienda è 1.",
      "minimumQuality": "L'azienda richiede almeno un utente di qualità.",
      "documentsHidden": "Questa azione causerebbe il nascondimento di uno o più documenti ai loro proprietari.",
      "templatesHidden": "Questa azione causerebbe il nascondimento di uno o più modelli ai loro proprietari.",
      "userAlreadyExists": "L'utente registrato con l'email {{email}} è già un membro di questa azienda.",
      "totalUsersLimit": "Limite di utenti totali raggiunto.",
      "activeUsersLimit": "Limite di utenti attivi raggiunto.",
      "userExistsInQualio": "Un utente esiste già in Qualio con questo indirizzo email."
    }
  },
  "emptyStates": {
    "noResults": "Nessun risultato trovato",
    "noData": "Non ci sono dati da visualizzare.",
    "noBetaFeatures": {
      "title": "Nessuna funzione beta attiva disponibile",
      "subtitle": "Controlla di nuovo in futuro. Stiamo sempre lavorando per migliorare l'esperienza di Qualio."
    },
    "noApiTokens": {
      "title": "Nessun token API creato",
      "subtitle": "Hai bisogno di un token API per script o test? Genera un token API per accedere rapidamente all'API Qualio.",
      "viewPortal": "Visualizza Portale sviluppatore",
      "createToken": "Crea token"
    },
    "noApiAccess": {
      "title": "Non hai accesso all'API sviluppatore",
      "subtitle": "Contatta il nostro team di supporto in modo da poter accedere all'API sviluppatore in Qualio.",
      "contactSupport": "Contatta il supporto Qualio"
    }
  },
  "security": {
    "description": "Gestisci i requisiti di autenticazione e le impostazioni di sicurezza per tutti gli utenti dell'organizzazione.",
    "mfa": {
      "label": "Autenticazione a più fattori",
      "description": "Richiedi a tutti gli utenti dell'organizzazione di fornire un codice di verifica oltre alla password al momento dell'accesso, migliorando la sicurezza complessiva.",
      "enable": "Abilita autenticazione a più fattori",
      "disableTitle": "Disabilita autenticazione a più fattori",
      "disableMessage": "Siete sicuri di voler disabilitare questa impostazione? Gli utenti non dovranno accedere utilizzando l'autenticazione a più fattori una volta disabilitata."
    }
  },
  "permissions": {
    "instancePermissions": "Autorizzazioni istanza",
    "aiEditing": {
      "label": "Modifica con IA",
      "description": "Valutazioni di formazione consigliate, controlli delle modifiche e miglioramenti dei documenti basati su intelligenza artificiale.",
      "enable": "Abilita modifica con IA"
    },
    "mcp": {
      "label": "Accesso MCP",
      "description": "Consenti agli assistenti e agli agenti IA di connettersi a questa istanza tramite il server MCP di Qualio.",
      "enable": "Abilita accesso MCP"
    },
    "copilot": {
      "label": "Qualio Copilot",
      "description": "Abilita l'assistente IA Qualio Copilot per questa istanza.",
      "enable": "Abilita Copilot"
    },
    "reviewers": {
      "label": "Revisori",
      "description": "Concedi agli utenti di base l'autorizzazione per essere aggiunti come revisore sui documenti.",
      "enable": "Tutti gli utenti di base possono essere revisori"
    },
    "supportAccess": {
      "label": "Accesso al supporto Qualio",
      "description": "Consenti al supporto Qualio di accedere all'istanza in modalità sola lettura.",
      "enable": "Abilita accesso al supporto"
    },
    "saveChanges": "Salva modifiche",
    "termsOfService": {
      "prefix": "Le autorizzazioni contrassegnate con",
      "tos": "abilitano funzionalità basate sull'IA. Abilitandole, accetti di essere vincolato dai Termini di servizio di Qualio.",
      "fairUsage": "Per garantire un'esperienza coerente per tutti gli utenti, potremmo introdurre limiti di utilizzo durante i periodi di alta domanda."
    }
  },
  "betaFeatures": {
    "description": "Esplora e testa le ultime funzioni che stiamo creando abilitandole nell'istanza. Il tuo feedback ci aiuta a perfezionare queste innovazioni, quindi facci sapere cosa ne pensi. Quando abiliti una funzione beta, potrebbe richiedere alcuni minuti affinché il cambiamento abbia effetto. Se non vedi i cambiamenti, prova ad aggiornare il browser. Scopri di più su queste funzioni nel nostro",
    "helpCenter": "Centro assistenza.",
    "packageNotice": "L'accesso alle funzioni beta dopo il rilascio generale può dipendere dal tuo pacchetto. Contatta il tuo CSM per saperne di più.",
    "enabled": "{{name}} abilitato",
    "disabled": "{{name}} disabilitato",
    "enable": "Abilita {{name}}",
    "termsOfService": {
      "prefix": "Facendo clic su un interruttore per abilitare una delle seguenti funzioni beta, accetti di essere vincolato da",
      "terms": "Termini di servizio di Qualio,",
      "middle": "per cui le funzioni beta che abiliti faranno parte delle \"Funzioni beta\" ai fini del",
      "suffix": "Termini di servizio."
    }
  },
  "devApi": {
    "backToTokens": "Torna ai token API",
    "createToken": "Crea token",
    "tokenRoleHelper": "Quale ruolo vorresti che avesse questo token?",
    "adminAccessHelper": "Concedi a questo token la possibilità di aggiungere/rimuovere utenti, aggiungere/rimuovere gruppi e gestire le autorizzazioni per eventi e fornitori.",
    "tokenGroupsHelper": "Facoltativamente aggiungi questo token ai gruppi per consentirgli di visualizzare documenti privati, eventi, ecc., proprio come un utente.",
    "editToken": "Modifica token"
  },
  "developerApi": {
    "description": "I token API sono chiavi univoche e sicure che consentono l'accesso autenticato all'API Qualio. Consentono l'integrazione senza problemi con sistemi esterni per automatizzare i flussi di lavoro, sincronizzare i dati e migliorare il tracciamento della conformità.",
    "manageDescription": "Qui è possibile gestire i token API. È possibile crearli, eliminarli e ruotarli. La rotazione di un token genererà una nuova chiave del token e invaliderà quella precedente. Il nome e le autorizzazioni non verranno modificati.",
    "expirationNote": "Ogni token scadrà dopo un anno, se non viene ruotato. Tutte le azioni eseguite utilizzando la chiave verranno registrate nel registro di audit con il nome che scegli per il token.",
    "docsAlert": "Stai effettuando un'integrazione con l'API di Qualio? Trova guide e il riferimento completo dell'API nel nostro portale per sviluppatori.",
    "viewApiDocs": "Visualizza la documentazione dell'API",
    "createToken": "Crea token",
    "backToTokens": "Torna ai token API",
    "createTokenHeader": "Crea token",
    "tokenName": "Nome",
    "tokenRole": "Ruolo",
    "tokenRoleHelper": "Quale ruolo vorresti che avesse questo token?",
    "tokenGroups": "Gruppi",
    "tokenGroupsHelper": "Facoltativamente aggiungi questo token ai gruppi per consentirgli di visualizzare documenti privati, eventi, ecc., proprio come un utente.",
    "adminAccessHelper": "Concedi a questo token la possibilità di aggiungere/rimuovere utenti, aggiungere/rimuovere gruppi e gestire le autorizzazioni per eventi e fornitori.",
    "tokenCreatedTitle": "Nuovo token creato",
    "storeSecurelyTitle": "Archivia questo token in modo sicuro",
    "storeSecurelyMessage": "Questo è l'unico momento in cui sarai in grado di visualizzare il token completo.",
    "apiTokenLabel": "Token API",
    "copyToken": "Copia token",
    "tokenLostWarning": "Se il token viene perso, dovrai generarne uno nuovo. La rigenerazione di un nuovo token invaliderà il token precedente, ma avrà le stesse autorizzazioni e lo stesso nome.",
    "deleteToken": "Elimina token API sviluppatore",
    "confirmDeleteTitle": "Conferma eliminazione token",
    "confirmDeleteMessage": "Vuoi davvero eliminare il token \"{{tokenName}}\"? Qualsiasi integrazione che utilizza questo token perderà immediatamente l'accesso all'API di Qualio.",
    "confirmRotateTitle": "Conferma rotazione token",
    "confirmRotateMessage": "Vuoi davvero ruotare il token \"{{tokenName}}\"? Verrà generata una nuova chiave token e quella attuale sarà invalidata immediatamente, quindi qualsiasi integrazione che la utilizza perderà l'accesso fino all'aggiornamento.",
    "table": {
      "name": "Nome",
      "created": "Creato",
      "expires": "Scade",
      "type": "Tipo",
      "personal": "Personale",
      "system": "Sistema",
      "personalTooltip": "Questo token è collegato a un utente reale e ne eredita gli accessi. Smetterà di funzionare se quell'utente viene disattivato.",
      "systemTooltip": "Questo token non è collegato a un utente reale e dispone di autorizzazioni proprie.",
      "rotate": "Ruota",
      "delete": "Elimina"
    }
  },
  "reassign": {
    "removeUserTitle": "Rimuovi utente: {{name}}",
    "removeUserTitleGeneric": "Rimuovi utente",
    "description": "Prima di rimuovere un utente, devi trasferire la proprietà dei documenti e dei problemi, delle attività e delle azioni in sospeso ad altri utenti.",
    "descriptionEvents": "Prima di rimuovere un utente, devi trasferire la proprietà dei documenti e degli eventi, delle attività e delle azioni in sospeso ad altri utenti.",
    "descriptionExtended": "Prima di rimuovere un utente, devi trasferire la proprietà dei documenti, dei modelli, dei problemi, delle attività e delle azioni in sospeso ad altri utenti.",
    "descriptionExtendedEvents": "Prima di rimuovere un utente, devi trasferire la proprietà dei documenti, dei modelli, degli eventi, delle attività e delle azioni in sospeso ad altri utenti.",
    "steps": {
      "documents": "Documenti",
      "changeRequests": "Richieste di modifica",
      "approvalActions": "Azioni di approvazione",
      "reviewActions": "Azioni di revisione",
      "issues": "Problemi",
      "tasks": "Attività",
      "confirmChanges": "Conferma modifiche e rimuovi utente",
      "defaultEventAssignee": "Assegnatario evento predefinito",
      "eventTemplates": "Modelli di evento",
      "controls": "Controlli",
      "documentTemplates": "Modelli di documento"
    },
    "bulkSelect": {
      "allSelected": "Tutti i {{size}} selezionati:",
      "save": "Salva"
    },
    "table": {
      "id": "ID",
      "title": "Titolo",
      "newOwner": "Nuovo proprietario",
      "status": "Stato",
      "tags": "Tag",
      "name": "Nome",
      "prefix": "Prefisso"
    },
    "summary": {
      "reviewInfo": "Rivedi le informazioni di seguito",
      "addUserToGroupTitle": "Aggiungi utente al gruppo",
      "addUserToGroupMessage": "Se procedi con la rimozione, i seguenti utenti verranno aggiunti ai seguenti gruppi necessari per accedere ai documenti con tag privati:",
      "userAddedToGroups": "{{userName}} verrà aggiunto ai gruppi: {{groupNames}}"
    }
  },
  "aria": {
    "userlistCheckbox": "userlist_checkbox",
    "addToGroup": "Add to group",
    "removeFromGroup": "Remove from group",
    "manageGroups": "Manage groups",
    "adminAccess": "admin access",
    "billingAccess": "billing access",
    "email": "email",
    "fullName": "fullName",
    "role": "role",
    "group": "group",
    "groupName": "group name",
    "includeInReports": "include in reports",
    "inviteUserForm": "inviteUserForm",
    "groupForm": "group form",
    "nextButton": "next_button",
    "canViewQualityEvents": "can view quality events",
    "canCreateQualityEvents": "can create quality events",
    "canEditQualityEvents": "can edit quality events",
    "canManageQualityEvents": "can manage quality events"
  }
}
